// this regular expression can test or check if a character is a digit
export const RE_DIGIT = new RegExp(/^\d+$/);
